import { useMemo } from 'react'

import { TKeyInitiative } from 'partner360/entities/keyInitiatives'
import { normalizeKeyInitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'

import { useKeyInitiativesFiltersForm } from './useKeyInitiativesFiltersForm'

interface IUseFilteredKeyInitiatives {
  data: TKeyInitiative[]
}

export const useFilteredKeyInitiatives = ({ data }: IUseFilteredKeyInitiatives) => {
  const {
    keyObjectives,
    statuses,
    countryCodes,
    businessPriorities: businessPriorityFilterValue,
    keyInitiativeIds,
  } = useKeyInitiativesFiltersForm()

  const filteredKeyInitiatives = useMemo(() => {
    return data.filter((item) => {
      if (keyInitiativeIds?.length) {
        return Boolean(item.EntryId && keyInitiativeIds.includes(item.EntryId))
      }

      const matchesKeyObjective =
        !keyObjectives?.length ||
        (item.Development !== null && keyObjectives.includes(item.Development))

      const matchesStatus =
        !statuses?.length ||
        statuses.some(
          (status) =>
            normalizeKeyInitiativeStatus(status) === normalizeKeyInitiativeStatus(item.Status)
        )

      const countryCode = 'CountryCode' in item ? item.CountryCode : undefined

      const matchesCountries =
        !countryCodes?.length || Boolean(countryCode && countryCodes.includes(countryCode))

      const businessPriorities =
        item.BusinessPriorities?.split(',')
          .map((x) => x.trim())
          .filter(Boolean) ?? []

      const matchesBusinessPriority =
        !businessPriorityFilterValue?.length ||
        businessPriorityFilterValue.some((bp) => businessPriorities.includes(bp))

      return (
        matchesKeyObjective &&
        matchesStatus &&
        matchesBusinessPriority &&
        matchesCountries &&
        item.Parent
      )
    })
  }, [data, keyInitiativeIds, keyObjectives, statuses, countryCodes, businessPriorityFilterValue])

  return {
    filteredKeyInitiatives,
  }
}
